/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { FOLDERS } from "../../../doseeData/utils/Utils";
import { ImageKitUpload } from "../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { useCountryContext } from "../../../../context/country/countryContext/CountryContext";
import {
  Title,
  TextArea,
  MyMessage,
  InputField,
  GoBackTool,
  PhoneInput,
  MyActionButton,
  SearchSelectInput,
} from "../../component/Component";
import { defaultImage } from "../../../../middlewares/libraries/imageKit/ImageKit";
import { useAdminContext } from "../../../../context/admin/context/AdminContext";

const Add = () => {
  const { superAdminCreateCompany } = useAdminContext();
  const { countries, fetchCountries } = useCountryContext();

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [name, setName] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [password, setPassword] = useState(null);
  const [country, setCountry] = useState("Uganda");
  const [website, setWebsite] = useState(null);
  const [email, setEmail] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [message, setErrorMessage] = useState(null);
  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [description, setDescription] = useState(null);

  const companyRoutes = "/company";

  useEffect(() => {
    if (!countries) fetchCountries();
  }, [countries, country]);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setDescription(null);
    setName(null);
    setWebsite(null);
    setCountry(null);
    setFirstName(null);
    setLastName(null);
    setEmail(null);
    setPassword(null);
  };

  const responses = (isError, successState, msg) => {
    setLoading(false);
    setError(isError);
    setSuccess(successState);
    setErrorMessage(msg);
  };

  const addOneCompanyHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, false, "Image Required");
    } else if (!isValid({ data: countries, value: country, key: "name" })) {
      responses(true, false, "Invalid Country");
    } else await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      name,
      thumbnail,
      image_cdn_id: thumbnailId,
      description,
      website,
      email,
      first_name: firstName,
      last_name: lastName,
      password,
      phonenumber: phoneNumber,
      country,
    };

    const { message: msg, status } = await superAdminCreateCompany(data);
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, true, msg);
    } else {
      responses(true, false, msg);
    }
  };

  const isValid = ({ data, value, key }) =>
    data?.find((x) => (x?.[key] === value ? true : false));

  const hasLogo = !!thumbnailId;
  const hasCountry = !!country;
  const hasAdmin = !!(firstName && lastName && email);

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 rounded-b-xl">
      <div className="mx-auto max-w-6xl space-y-5">
        <GoBackTool route={companyRoutes} />

        <div className="relative">
          <div className="pointer-events-none absolute -inset-x-6 -top-6 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex flex-col gap-4 p-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h1 className="text-base font-semibold tracking-tight text-gray-900">
                  Add Company
                </h1>
                <p className="mt-0.5 text-xs text-gray-600">
                  Upload brand assets and set up the company and primary admin.
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                <StatusChip label="Logo" ok={hasLogo} />
                <StatusChip label="Country" ok={hasCountry} />
                <StatusChip label="Admin Details" ok={hasAdmin} />
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={addOneCompanyHandler} className="space-y-5">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />

          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3 flex items-center justify-between">
              <Title props={{ title: "Brand & Identity" }} />
              <span className="text-[11px] text-gray-500">JPG/PNG • Square preferred</span>
            </div>
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              <div className="rounded-xl border border-dashed border-gray-200 p-3">
                <p className="mb-2 text-xs font-semibold text-gray-700">Company Logo</p>
                <ImageKitUpload
                  thumbnail={thumbnail}
                  thumbnailId={thumbnailId}
                  setThumbnail={setThumbnail}
                  setThumbnailId={setThumbnailId}
                  folder={FOLDERS.COMPANY}
                />
              </div>
              <div className="rounded-xl border border-dashed border-gray-200 p-3">
                <p className="mb-2 text-xs font-semibold text-gray-700">Preview</p>
                <div className="grid h-40 place-items-center rounded-xl bg-gray-50 ring-1 ring-gray-200 text-xs text-gray-500">
                  {hasLogo ? "Ready to upload" : "No logo selected"}
                </div>
              </div>
            </div>
          </section>

          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "Company Details" }} />
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
              <InputField
                props={{
                  id: "company_name",
                  title: "Company Name",
                  type: "text",
                  value: name ? name : "",
                  onChange: (e) => {
                    setName(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "website",
                  title: "Company Website",
                  type: "text",
                  value: website ? website : "",
                  onChange: (e) => {
                    setWebsite(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <SearchSelectInput
                title="Country"
                value={country ? country : null}
                options={countries ? countries?.map((x) => x?.name) : []}
                onChange={(v) => setCountry(v)}
              />
            </div>
          </section>

          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "Primary Admin" }} />
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
              <InputField
                props={{
                  id: "first_name",
                  title: "First Name",
                  type: "text",
                  value: firstName ? firstName : "",
                  onChange: (e) => {
                    setFirstName(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "last_name",
                  title: "Last Name",
                  type: "text",
                  value: lastName ? lastName : "",
                  onChange: (e) => {
                    setLastName(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "text",
                  value: email ? email : "",
                  onChange: (e) => {
                    setEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <PhoneInput
                setPhone={setPhoneNumber}
                phone={phoneNumber}
                required={false}
                country={country}
              />
              <InputField
                props={{
                  id: "password",
                  title: "Password",
                  type: "password",
                  value: password ? password : "",
                  onChange: (e) => {
                    setPassword(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "More Settings" }} />
            </div>
            <TextArea
              props={{
                id: "description",
                title: "Description",
                type: "text",
                value: description ? description : "",
                onChange: (e) => {
                  setDescription(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
            <div className="mt-3 inline-flex items-center gap-2 rounded-md bg-gray-50 px-2.5 py-2 text-[11px] text-gray-700 ring-1 ring-gray-200">
              <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
              You can add more admins after creating the company.
            </div>
          </section>

          <div className="flex items-center justify-end">
            <div className="flex w-full items-center justify-center rounded-xl bg-white shadow-sm ring-1 ring-gray-200 p-2">
              <MyActionButton
                className="min-w-[200px]"
                loading={loading}
                title="Add New Company"
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;

const StatusChip = ({ label, ok }) => {
  return (
    <span
      className={[
        "inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-[11px] font-medium ring-1",
        ok
          ? "bg-emerald-50 text-emerald-700 ring-emerald-200"
          : "bg-gray-50 text-gray-600 ring-gray-200",
      ].join(" ")}
    >
      <span
        className={["h-1.5 w-1.5 rounded-full", ok ? "bg-emerald-500" : "bg-gray-300"].join(" ")}
      />
      {label}
    </span>
  );
};
